import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';

const isLocalhost = ['localhost', '127.0.0.1']
  .includes(window.location.hostname);

if (!isLocalhost) {
  const noop = () => {};
  console.log = noop;
  console.debug = noop;
  console.info = noop;
  console.warn = noop;
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
